import { get } from '../../../utils/get';
export var getEventUrl = function getEventUrl(item) {
  if (item === void 0) {
    item = {};
  }

  return get(item, 'event.eventPageUrl.base').concat(get(item, 'event.eventPageUrl.path'));
};